import { createContext } from 'react';
import type { DataStore } from '@/storage';

export const StorageContext = createContext<DataStore | null>(null);
